// src/components/LocationCard/LocationCard.jsx
import React from "react"
import styled from "styled-components"
import { FiMapPin } from "react-icons/fi"

// ===== styled-components =====
const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 12px;
  padding: 1rem 1.2rem;
  gap: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  margin-bottom: 15px;
`

const Info = styled.div`
  flex: 1;
`

const Name = styled.h4`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
`

const Icon = styled(FiMapPin)`
  color: #d52b1e;
`

const Address = styled.p`
  font-size: 0.9rem;
  color: #444;
  margin: 0.2rem 0 0 1.5rem;
`

const MapWrapper = styled.div`
  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`

// ===== Componente principal =====
export default function LocationCard({ name, address }) {
    return (
        <Card>
            <Info>
                <Name>
                    <Icon /> {name}
                </Name>
                <Address>{address}</Address>
            </Info>

            <MapWrapper>
                <img
                    src="https://cdn-icons-png.flaticon.com/512/854/854878.png"
                    alt="mapa"
                />
            </MapWrapper>
        </Card>
    )
}